module.exports = __webpack_public_path__ + "img/invite2.30a97a8a.png";